import { Fancybox } from "@fancyapps/ui";

Fancybox.bind("[data-fancybox]", {
  hideClass: false,
  zoomEffect: false,
  placeFocusBack: false,
});
